import type { Settings } from '../api/client/types.gen'
import { ref, rtdb } from '.'
import { listenToRTDB } from './utils'

export function subscribeToSettings(callback: (settings: Settings) => void) {
  const settingsRef = ref(rtdb, 'settings')
  return listenToRTDB<Settings>(
    settingsRef,
    (data) => {
      callback(data || {})
    },
    {
      onError: (error) => {
        console.error('Settings subscription error:', error)
      },
    },
  )
}
